import { createContext } from "react";
const AdminContext = createContext();
const AdminProvider = ({ children }) => {
  return <AdminContext.Provider value={true}>{children}</AdminContext.Provider>;
};
export { AdminProvider, AdminContext };
